import * as types from "./actionType";

const initialState = {

    // Total Data Count
    totalDataCount: null,
    // Total Data Count

    // SideMenu
    sideMenus: [],
    // SideMenu

    // Module Permissions
    modulePermissions: [],
    // Module Permissions

    // SignIn generate token
    signInToken: "",
    // SignIn generate token

    // Profile Settings
    getProfileDetails: [],
    getTimeZoneDropdown: [],
    getProfilePasswordOtp: {},
    // Profile Settings

    // Customer Management
    assignedModulesDropdown: [],
    companyData: [],
    singleCustomerData: {},
    getCountryCodeDropdownData: [],
    getCompanyDropdown: [],
    getGeneratedCompanyCode: [],
    getCompanyCustomFields: [],
    getCustomerClassificationDropdown: [],
    getCustomerDashboardCardData: [],
    getCustomerDetailsChartData: {},
    getCustomerDashboardRelationShipTypeData: {},
    getCustomerDashboardLicenceSplitUpData: [],
    getCustomerDashboardStatusChartData: {},
    getCustomerDashboardAssignedModulesData: [],
    getCustomerDashboardNoofLicenceChartData: {},
    customerModuleFieldDropdownData: [],
    // Customer Management

    // User Management
    userData: [],
    singleUserData: {},
    rolesDropdown: [],
    reportingToDropdown: [],
    slocDropdown: [],
    branchDropdown: [],
    businessUnitDropdown: [],
    getUserCustomFields: [],
    getUserDropdown: [],
    getUserReportingDesignationDropdown: [],
    getLicenceDashboardCardData: [],
    usersModuleFieldDropdownData: [],
    getUserCustomFieldData: [],
    getLicenseDashboardLicenceStatusData: [],
    getLicenceDashboardBarChartlicenceDetailsData: [],
    getLicenceDashboardBarChartLicenceSplitUpData: [],
    // User Management

    // Complaint/Escalation 
    complainEscalationData: [],
    singleComplaintEscalationData: {},
    issueTypeDropdownData: [],
    complaintEscalationDashboardCardData: {},
    complaintEscalationBarChartTicketData: [],
    complaintEscalationPriorityStatusData: [],
    complaintEscalationStatusData: {},
    complaintEscalationBranchStatusData: [],
    complaintEscalationIssueTypeData: [],
    complaintEscalationModuleFieldDropdownData: [],
    complaintEscalationStatusDropdownData: [],
    complaintEscalationHistoryData: {},
    technicalData: [],
    QAData: [],
    userSlocsDropdown: [],
    // Complaint/Escalation 

    // Service Level Agreement
    assignedToSlaData: [],
    singleAssignedToSlaData: {},
    assignedToSlaTypeDropdownData: [],
    getSlaCategoryDropdown: [],
    getSlaDashboardCardData: {},
    getSlaDashboardSlaTypeStatusChartData: {},
    getSlaDashboardSlaTypesChartData: {},
    getSlaDashboardAssignedScoreData: {},
    getSlaDashboardTotalSlaChartData: [],
    getSlaDashboardChecklistStatusChartData: {},
    assignToSlaModuleFieldDropdownData: [],
    updateSlaData: [],
    // Service Level Agreement

    // Workqueues
    workqueuesData: [],
    singleWorkqueuesData: [],
    userDropdownBasedDepartment: [],
    getWorkqueueModuleFieldDropdown: [],
    getViewAssignedWorkqueueData: [],
    // Workqueues

    // Leave and Holiday
    leaveBalanceData: [],
    singleLeaveBalanceData: {},
    leaveData: [],
    pendingLeaveData: [],
    approvedLeaveData: [],
    rejectedLeaveData: [],
    singleLeaveData: {},
    leavesCount: [],
    // Leave and Holiday

    // System Logging
    getModuleNameForSystemLogging: [],
    // Exception Log
    getExceptionLoggingData: [],
    getSingleExceptionLoggingData: {},
    // Exception Log

    // Audit Trial
    getAuditTrialData: [],
    // Audit Trial
    // System Logging


    // Settings Department
    departmentData: [],
    singleDepartmentData: [],
    departmentModulefieldDropdown: [],
    // Settings Department

    // Settings Customer Classification
    customerClassificationData: [],
    singleCustomerClassificationData: {},
    customerClassificationModuleFieldDropdown: [],
    // Settings Customer Classification

    // Settings Designation
    designationData: [],
    departmentDropdown: [],
    reportingDesignationDropdown: [],
    singleDesignationData: {},
    // Settings Designation

    // Settings Issue Types
    issueTypesData: [],
    singleIssueTypesData: {},
    issueTypeModuleFieldDropdown: [],
    // Settings Issue Types

    // Settings SLA
    SettingSlaData: [],
    SingleSettingSlaData: {},
    slaCategoriesModuleFieldDropdown: [],
    // Settings SLA

    // Settings Module
    moduleData: [],
    singleModuleData: {},
    // Settings Module

    // Settings Sub Module
    subModuleData: [],
    singleSubModuleData: {},
    subModuleDropdown: [],
    // Settings Sub Module

    // Settings System Numbering
    systemNumberingData: [],
    singleSystemNumberingData: {},
    systemNumberingModuleFieldDropdown: [],
    // Settings System Numbering

    // Settings Work Queues Rules
    settingsWorkQueuesRulesData: [],
    settingsSingleWorkQueuesRulesData: [],
    getSettingsWorkQuesRulesFieldNameData: [],
    settingsWorkQueueRuleModuleFieldDropdown: [],
    // Settings Work Queues Rules

    // Settings Role
    getRolesData: [],
    getSingleRolesData: {},
    getModulesSubmodulesData: [],
    getRolesModuleFieldDropdownData: [],
    // Settings Role

    // Settings Custom Fields
    getCustomFields: [],
    getSingleCustomFields: {},
    CustomFieldsModuleFieldDropdown: [],
    // Settings Custom Fields

    // Settings Leave Policy
    getLeavePolicyData: [],
    getSingleLeavePolicyData: {},
    getLeaveTypeDropdown: [],
    getLeavePolicyModuleFieldDropdown: [],
    // Settings Leave Policy

    // Settings Holiday Policy
    getHolidayPolicyData: [],
    getSingleHolidayPolicyData: [],
    getCountryNameDropdown: [],
    getHolidayNameDropdown: [],
    getHolidayPolicyModuleFieldDropdown: [],
    // Settings Holiday Policy

    // Settings Financial Approval
    financialApprovalData: [],
    singleFinancialApprovalData: {},
    approvalLevelDropdown: [],
    financialApprovalModuleFieldDropdown: [],
    // Settings Financial Approval

    // Settings Functional Approval
    functionalApprovalData: [],
    singleFunctionalApprovalData: {},
    functionalApprovalModuleFieldDropdown: [],
    // Settings Functional Approval

    // Settings Leave Approval
    leaveApprovalData: [],
    singleLeaveApprovalData: {},
    leaveApprovalModuleFieldDropdown: [],
    // Settings Leave Approval

    // Settings Escalation Approval
    escalationApprovalData: [],
    singleEscalationApprovalData: {},
    escalationApprovalModuleFieldDropdown: [],
    // Settings Escalation Approval

    // Settings Complaints Approval
    complaintsApprovalData: [],
    singleComplaintsApprovalData: {},
    complaintApprovalModuleFieldDropdown: [],
    // Settings Complaints Approval

    // Settings Organization Chart
    getOrganizationChart: [],
    // Settings Organization Chart

    // Settings Menubar Enable and Disable
    getModuleSubModules: [],
    // Settings Menubar Enable and Disable

    // Settings Dynamic Dashboard
    getDynamicDashboardData: [],
    getDynamicDashboardCategoryDropdownData: [],
    getSingleDynamicDashboardData: {},
    // Settings Dynamic Dashboard

    // Settings Module Fields
    getModuleFieldData: [],
    getColumnNameData: [],
    getSingleModuleFieldData: {},
    // Settings Module Fields

    loading: true,
}

const designReducers = (state = initialState, action) => {
    // eslint-disable-next-line default-case
    switch (action.type) {

        // Module Permissions
        case types.get_Role_Based_Module_Permissions:
            return {
                ...state,
                modulePermissions: action.payload,
                loading: false,
            };
        // Module Permissions
        // SideMenu
        case types.get_SideMenus:
            return {
                ...state,
                sideMenus: action.payload,
                loading: false,
            };
        // SideMenu
        // SignIn Page
        case types.post_SignIn_Data:
        case types.post_resendOtp_Data:
        // SignIn Page

        // Verify Company
        // eslint-disable-next-line no-fallthrough
        case types.post_Resend_Verify_Email:
        // Verify Company

        // Forgot Password 
        // eslint-disable-next-line no-fallthrough
        case types.post_Forgot_Password:
        // Forgot Password 

        // Reset Password
        // eslint-disable-next-line no-fallthrough
        case types.post_Reset_Password:
        // Reset Password

        // Total Data Count
        // eslint-disable-next-line no-fallthrough
        case types.Get_Total_Data_Count:
            return {
                ...state,
                totalDataCount: action.payload,
                loading: false,
            };
        // Total Data Count

        // Switch To Client
        case types.post_Switch_To_Client:
        // Switch To Client

        // Switch To SuperAdmin
        // eslint-disable-next-line no-fallthrough
        case types.post_Switch_To_SuperAdmin:
        // Switch To SuperAdmin

        // SignIn generate token
        // eslint-disable-next-line no-fallthrough
        case types.get_SignIn_Token:
            return {
                ...state,
                signInToken: action.payload,
                loading: false,
            };
        // SignIn generate token

        // Profile Settings Set Password
        // eslint-disable-next-line no-fallthrough
        case types.update_Profile_Data:
        case types.post_Profile_Settings_Set_Password:
        case types.get_Profile_Details:
            return {
                ...state,
                getProfileDetails: action.payload,
                loading: false,
            };
        case types.get_Profile_Password_Otp:
            return {
                ...state,
                getProfilePasswordOtp: action.payload,
                loading: false,
            };
        case types.get_TimeZone_Dropdown:
            return {
                ...state,
                getTimeZoneDropdown: action.payload,
                loading: false,
            };
        // Profile Settings Set Password

        // Customer Management
        // eslint-disable-next-line no-fallthrough
        case types.post_Customer_Data:
        case types.post_Custom_Fields_Value_For_Company:
        case types.get_Assigned_Modules:
            return {
                ...state,
                assignedModulesDropdown: action.payload,
                loading: false,
            };
        case types.get_Company_Data:
            return {
                ...state,
                companyData: action.payload,
                loading: false,
            };
        case types.get_Single_Company_Data:
            return {
                ...state,
                singleCustomerData: action.payload,
                loading: false,
            };
        case types.get_Country_Code:
            return {
                ...state,
                getCountryCodeDropdownData: action.payload,
                loading: false,
            };
        case types.get_Company_Dropdown:
            return {
                ...state,
                getCompanyDropdown: action.payload,
                loading: false,
            };
        case types.get_generated_Company_Code:
            return {
                ...state,
                getGeneratedCompanyCode: action.payload,
                loading: false,
            };
        case types.get_Custom_Fields_For_Company:
            return {
                ...state,
                getCompanyCustomFields: action.payload,
                loading: false,
            };
        case types.get_Customer_Classification_Dropdown:
            return {
                ...state,
                getCustomerClassificationDropdown: action.payload,
                loading: false,
            };
        case types.get_Customer_Dashboard_CardData:
            return {
                ...state,
                getCustomerDashboardCardData: action.payload,
                loading: false,
            };
        case types.get_Customer_Details_ChartData:
            return {
                ...state,
                getCustomerDetailsChartData: action.payload,
                loading: false,
            };
        case types.get_Customer_Dashboard_RelationShipType_Chart:
            return {
                ...state,
                getCustomerDashboardRelationShipTypeData: action.payload,
                loading: false,
            };
        case types.get_Customer_Dashboard_LicenceSplitUp_Data:
            return {
                ...state,
                getCustomerDashboardLicenceSplitUpData: action.payload,
                loading: false,
            };
        case types.get_Customer_Dashboard_Status_ChartData:
            return {
                ...state,
                getCustomerDashboardStatusChartData: action.payload,
                loading: false,
            };
        case types.get_Customer_Dashborad_AssignedModules_Data:
            return {
                ...state,
                getCustomerDashboardAssignedModulesData: action.payload,
                loading: false,
            };
        case types.get_Customer_Dashboard_NoOfLicence_ChartData:
            return {
                ...state,
                getCustomerDashboardNoofLicenceChartData: action.payload,
                loading: false,
            };
        case types.get_Customer_ModuleField_Dropdown:
            return {
                ...state,
                customerModuleFieldDropdownData: action.payload,
                loading: false,
            };
        // Customer Management

        // User Management
        case types.post_User_Data:
        case types.post_Assign_Complaint_Data:
        case types.post_Complaint_Escalation_Status_Change:
        case types.post_User_Sloc_Data:
        case types.get_Role_Dropdown_Data:
            return {
                ...state,
                rolesDropdown: action.payload,
                loading: false,
            };
        case types.get_ReportingTo_Dropdown_Data:
            return {
                ...state,
                reportingToDropdown: action.payload,
                loading: false,
            };
        case types.get_User_Data:
            return {
                ...state,
                userData: action.payload,
                loading: false,
            };
        case types.get_Single_User_Data:
            return {
                ...state,
                singleUserData: action.payload,
                loading: false,
            };
        case types.get_Sloc_Dropdown_Data:
            return {
                ...state,
                slocDropdown: action.payload,
                loading: false,
            };
        case types.get_Branch_Dropdown_Data:
            return {
                ...state,
                branchDropdown: action.payload,
                loading: false,
            };
        case types.get_BusinessUnit_Dropdown_Data:
            return {
                ...state,
                businessUnitDropdown: action.payload,
                loading: false,
            };
        case types.get_Custom_Fields_For_Users:
            return {
                ...state,
                getUserCustomFields: action.payload,
                loading: false,
            };
        case types.get_User_Dropdown:
            return {
                ...state,
                getUserDropdown: action.payload,
                loading: false,
            };
        case types.get_User_Reporting_Designation_Dropdown:
            return {
                ...state,
                getUserReportingDesignationDropdown: action.payload,
                loading: false,
            };
        case types.get_Licence_Dashboard_CardData:
            return {
                ...state,
                getLicenceDashboardCardData: action.payload,
                loading: false,
            };
        case types.get_Users_ModuleField_Dropdown:
            return {
                ...state,
                usersModuleFieldDropdownData: action.payload,
                loading: false,
            };
        case types.get_User_CustomField_Data:
            return {
                ...state,
                getUserCustomFieldData: action.payload,
                loading: false,
            };
        case types.get_User_Dashboard_Licence_Status_Data:
            return {
                ...state,
                getLicenseDashboardLicenceStatusData: action.payload,
                loading: false,
            };
        case types.get_Licence_Dashboard_BarChart_Licence_Details_Data:
            return {
                ...state,
                getLicenceDashboardBarChartlicenceDetailsData: action.payload,
                loading: false,
            };
        case types.get_Licence_Dashboard_BarChart_Licence_Split_Up_Data:
            return {
                ...state,
                getLicenceDashboardBarChartLicenceSplitUpData: action.payload,
                loading: false,
            };
        // User Management

        // Complaint/Escalation 
        case types.post_Complaint_Escalation_Data:
        case types.post_Complaint_Escalation_ERT_Data:
        case types.upload_File:
        case types.get_Complaint_Data:
            return {
                ...state,
                complainEscalationData: action.payload,
                loading: false,
            };
        case types.get_Single_Complaint_Data:
            return {
                ...state,
                singleComplaintEscalationData: action.payload,
                loading: false,
            };
        case types.get_IssueType_Dropdown_Data:
            return {
                ...state,
                issueTypeDropdownData: action.payload,
                loading: false,
            };
        case types.get_Complaint_Escalation_Dashboard_CardData:
            return {
                ...state,
                complaintEscalationDashboardCardData: action.payload,
                loading: false,
            };
        case types.get_Complaint_Escalation_Ticket_Data:
            return {
                ...state,
                complaintEscalationBarChartTicketData: action.payload,
                loading: false,
            };
        case types.get_Complaint_Escalation_PriorityStatus_Data:
            return {
                ...state,
                complaintEscalationPriorityStatusData: action.payload,
                loading: false,
            };
        case types.get_Complaint_Escalation_Status_Data:
            return {
                ...state,
                complaintEscalationStatusData: action.payload,
                loading: false,
            };
        case types.get_Complaint_Escalation_BranchStatus_Data:
            return {
                ...state,
                complaintEscalationBranchStatusData: action.payload,
                loading: false,
            };
        case types.get_Complaint_Escalation_IssueType_Data:
            return {
                ...state,
                complaintEscalationIssueTypeData: action.payload,
                loading: false,
            };
        case types.get_Complaint_Escalation_ModuleField_Dropdown:
            return {
                ...state,
                complaintEscalationModuleFieldDropdownData: action.payload,
                loading: false,
            };
        case types.get_Complaint_Status_Dropdown:
            return {
                ...state,
                complaintEscalationStatusDropdownData: action.payload,
                loading: false,
            };
        case types.get_Complaint_History_Data:
            return {
                ...state,
                complaintEscalationHistoryData: action.payload,
                loading: false,
            };
        case types.get_Technical_Data:
            return {
                ...state,
                technicalData: action.payload,
                loading: false,
            };
        case types.get_QA_Data:
            return {
                ...state,
                QAData: action.payload,
                loading: false,
            };
        case types.get_User_Slocs_Dropdown:
            return {
                ...state,
                userSlocsDropdown: action.payload,
                loading: false,
            };
        // Complaint/Escalation 

        // Service Level Agreement
        case types.post_AssignedTo_SLA_Data:
        case types.post_Update_SLA_Data:
        case types.get_AssignedTo_SLA_Data:
            return {
                ...state,
                assignedToSlaData: action.payload,
                loading: false,
            };
        case types.get_Single_AssignedTo_SLA_Data:
            return {
                ...state,
                singleAssignedToSlaData: action.payload,
                loading: false,
            };
        case types.get_AssignedTo_SLA_Type_Dropdown:
            return {
                ...state,
                assignedToSlaTypeDropdownData: action.payload,
                loading: false,
            };
        case types.get_SLA_Category_Dropdown:
            return {
                ...state,
                getSlaCategoryDropdown: action.payload,
                loading: false,
            };
        case types.get_SLA_Dashboard_CardData:
            return {
                ...state,
                getSlaDashboardCardData: action.payload,
                loading: false,
            };
        case types.get_SLA_Dashboard_SLA_Type_Status_Chart_Data:
            return {
                ...state,
                getSlaDashboardSlaTypeStatusChartData: action.payload,
                loading: false,
            };
        case types.get_SLA_Dashboard_SLA_Types_Chart_Data:
            return {
                ...state,
                getSlaDashboardSlaTypesChartData: action.payload,
                loading: false,
            };
        case types.get_SLA_Dashboard_AssignedScore_Data:
            return {
                ...state,
                getSlaDashboardAssignedScoreData: action.payload,
                loading: false,
            };
        case types.get_SLA_Dashboard_Total_SLA_Chart_Data:
            return {
                ...state,
                getSlaDashboardTotalSlaChartData: action.payload,
                loading: false,
            };
        case types.get_SLA_Dashboard_Checklist_Status_Chart_Data:
            return {
                ...state,
                getSlaDashboardChecklistStatusChartData: action.payload,
                loading: false,
            };
        case types.get_AssignTo_SLA_ModuleField_Dropdown:
            return {
                ...state,
                assignToSlaModuleFieldDropdownData: action.payload,
                loading: false,
            };
        case types.get_Update_SLA_Data:
            return {
                ...state,
                updateSlaData: action.payload,
                loading: false,
            };
        // Service Level Agreement

        // Workqueues
        case types.update_Workqueue_Priority_Status:
        case types.post_Set_AssignTo_Data:
        case types.get_Workqueue_Data:
            return {
                ...state,
                workqueuesData: action.payload,
                loading: false,
            };
        case types.get_Single_Workqueue_Data:
            return {
                ...state,
                singleWorkqueuesData: action.payload,
                loading: false,
            };
        case types.get_User_Dropdown_Based_Department:
            return {
                ...state,
                userDropdownBasedDepartment: action.payload,
                loading: false,
            };
        case types.get_Workqueue_ModuleField_Dropdown:
            return {
                ...state,
                getWorkqueueModuleFieldDropdown: action.payload,
                loading: false,
            };
        case types.get_View_Assigned_Workqueue_Data:
            return {
                ...state,
                getViewAssignedWorkqueueData: action.payload,
                loading: false,
            };
        // Workqueues

        // Leave and Holiday
        case types.post_Leave_Balance_Data:
        case types.post_Apply_Leave:
        case types.update_Leave_Status:
        case types.get_Leave_Balance_Data:
            return {
                ...state,
                leaveBalanceData: action.payload,
                loading: false,
            };
        case types.get_Single_Leave_Balance_Data:
            return {
                ...state,
                singleLeaveBalanceData: action.payload,
                loading: false,
            };
        case types.get_Leave_Data:
            return {
                ...state,
                leaveData: action.payload,
                loading: false,
            };
        case types.get_Pending_Leave_Data:
            return {
                ...state,
                pendingLeaveData: action.payload,
                loading: false,
            };
        case types.get_Approved_Leave_Data:
            return {
                ...state,
                approvedLeaveData: action.payload,
                loading: false,
            };
        case types.get_Rejected_Leave_Data:
            return {
                ...state,
                rejectedLeaveData: action.payload,
                loading: false,
            };
        case types.get_Single_Leave_Data:
            return {
                ...state,
                singleLeaveData: action.payload,
                loading: false,
            };
        case types.get_Leaves_Count:
            return {
                ...state,
                leavesCount: action.payload,
                loading: false,
            };
        // Leave and Holiday

        // System Logging
        case types.get_ModuleName_For_SystemLogging:
            return {
                ...state,
                getModuleNameForSystemLogging: action.payload,
                loading: false,
            }
        // Exception Log
        case types.get_Exception_Logging_Data:
            return {
                ...state,
                getExceptionLoggingData: action.payload,
                loading: false,
            };
        case types.get_Single_Exception_Logging_Data:
            return {
                ...state,
                getSingleExceptionLoggingData: action.payload,
                loading: false,
            };
        // Exception Log

        // Audit Trial
        case types.get_Audit_Trial_Data:
            return {
                ...state,
                getAuditTrialData: action.payload,
                loading: false,
            };
        // Audit Trial
        // System Logging

        // Settings Department
        case types.post_Department_Data:
        case types.get_Department_Data:
            return {
                ...state,
                departmentData: action.payload,
                loading: false,
            }
        case types.get_Single_Department_Data:
            return {
                ...state,
                singleDepartmentData: action.payload,
                loading: false,
            }
        case types.get_Department_ModuleField_Dropdown:
            return {
                ...state,
                departmentModulefieldDropdown: action.payload,
                loading: false,
            }
        // Settings Department

        // Settings Customer Classification
        case types.post_Customer_Classification_Data:
        case types.get_Customer_Classification_Data:
            return {
                ...state,
                customerClassificationData: action.payload,
                loading: false,
            }
        case types.get_Single_Customer_Classification_Data:
            return {
                ...state,
                singleCustomerClassificationData: action.payload,
                loading: false,
            }
        case types.get_Customer_Classification_ModuleField_Dropdown:
            return {
                ...state,
                customerClassificationModuleFieldDropdown: action.payload,
                loading: false,
            }
        // Settings Customer Classification

        // Settings Designation
        case types.post_Designation_Data:
        case types.get_Designation_Data:
            return {
                ...state,
                designationData: action.payload,
                loading: false,
            }
        case types.get_Department_Dropdown:
            return {
                ...state,
                departmentDropdown: action.payload,
                loading: false,
            }
        case types.get_Reporting_Designation_Dropdown:
            return {
                ...state,
                reportingDesignationDropdown: action.payload,
                loading: false,
            }
        case types.get_Single_Designation_Data:
            return {
                ...state,
                singleDesignationData: action.payload,
                loading: false,
            }
        case types.get_Designation_ModuleField_Dropdown:
            return {
                ...state,
                designationModuleFieldDropdown: action.payload,
                loading: false,
            }
        // Settings Designation

        // Settings IssueTypes
        case types.post_Issue_Types_Data:
        case types.get_Issue_Type_Data:
            return {
                ...state,
                issueTypesData: action.payload,
                loading: false,
            }
        case types.get_Single_Issue_Types_Data:
            return {
                ...state,
                singleIssueTypesData: action.payload,
                loading: false,
            }
        case types.get_Issue_Type_ModuleField_Dropdown:
            return {
                ...state,
                issueTypeModuleFieldDropdown: action.payload,
                loading: false,
            }
        // Settings IssueTypes

        // Settings SLA
        case types.post_Settings_SLA_Data:
        case types.get_Settings_SLA_Data:
            return {
                ...state,
                SettingSlaData: action.payload,
                loading: false,
            }
        case types.get_Single_Settings_SLA_Data:
            return {
                ...state,
                SingleSettingSlaData: action.payload,
                loading: false,
            }
        case types.get_Settings_SLA_ModuleField_Dropdown:
            return {
                ...state,
                slaCategoriesModuleFieldDropdown: action.payload,
                loading: false,
            }
        // Settings SLA

        // Settings Module
        case types.post_Modules_Data:
        case types.get_Module_Data:
            return {
                ...state,
                moduleData: action.payload,
                loading: false,
            }
        case types.get_Single_Module_Data:
            return {
                ...state,
                singleModuleData: action.payload,
                loading: false,
            }
        // Settings Module

        // Settings Sub Module
        case types.post_Sub_Modules_Data:
        case types.get_Sub_Module_Data:
            return {
                ...state,
                subModuleData: action.payload,
                loading: false,
            }
        case types.get_Single_Sub_Module_Data:
            return {
                ...state,
                singleSubModuleData: action.payload,
                loading: false,
            }
        case types.get_SubModule_Dropdown:
            return {
                ...state,
                subModuleDropdown: action.payload,
                loading: false,
            }
        // Settings Sub Module

        // Settings System Numbering
        case types.post_System_Numbering:
        case types.get_System_Numbering:
            return {
                ...state,
                systemNumberingData: action.payload,
                loading: false,
            }
        case types.get_Singel_System_Numbering:
            return {
                ...state,
                singleSystemNumberingData: action.payload,
                loading: false,
            }
        case types.get_System_Numbering_ModuleField_Dropdown:
            return {
                ...state,
                systemNumberingModuleFieldDropdown: action.payload,
                loading: false,
            }
        // Settings System Numbering


        // Settings Work Queues Rules
        case types.post_Settings_WorkQueues_Rule_Data:
        case types.post_Run_WorkQueue_Data:
        case types.get_Settings_WorkQueues_Rule:
            return {
                ...state,
                settingsWorkQueuesRulesData: action.payload,
                loading: false,
            }
        case types.get_Settings_Single_WorkQueues_Rule:
            return {
                ...state,
                settingsSingleWorkQueuesRulesData: action.payload,
                loading: false,
            }
        case types.get_Settings_WorkQueues_FieldName_Rule:
            return {
                ...state,
                getSettingsWorkQuesRulesFieldNameData: action.payload,
                loading: false,
            }
        case types.get_WorkQueue_Rule_ModuleField_Dropdown:
            return {
                ...state,
                settingsWorkQueueRuleModuleFieldDropdown: action.payload,
                loading: false,
            }
        // Settings Work Queues Rules

        // Settings Role
        case types.post_Roles_Data:
        case types.get_Roles_Data:
            return {
                ...state,
                getRolesData: action.payload,
                loading: false,
            }
        case types.get_Single_Roles_Data:
            return {
                ...state,
                getSingleRolesData: action.payload,
                loading: false,
            }
        case types.get_Modules_SubModules_Data:
            return {
                ...state,
                getModulesSubmodulesData: action.payload,
                loading: false,
            }
        case types.get_Roles_ModuleField_Dropdown:
            return {
                ...state,
                getRolesModuleFieldDropdownData: action.payload,
                loading: false,
            }
        // Settings Role

        // Settings Custom Fields
        case types.post_CustomFields_Data:
        case types.get_CustomFields_Data:
            return {
                ...state,
                getCustomFields: action.payload,
                loading: false,
            }
        case types.get_Single_CustomFields_Data:
            return {
                ...state,
                getSingleCustomFields: action.payload,
                loading: false,
            }
        case types.get_CustomFields_ModuleField_Dropdown:
            return {
                ...state,
                CustomFieldsModuleFieldDropdown: action.payload,
                loading: false,
            }
        // Settings Custom Fields

        // Settings Leave Policy
        case types.post_Leave_Policy_Data:
        case types.get_Leave_Policy_Data:
            return {
                ...state,
                getLeavePolicyData: action.payload,
                loading: false,
            }
        case types.get_Single_Leave_Policy_Data:
            return {
                ...state,
                getSingleLeavePolicyData: action.payload,
                loading: false,
            }
        case types.get_Leave_Type_Dropdown:
            return {
                ...state,
                getLeaveTypeDropdown: action.payload,
                loading: false,
            }
        case types.get_Leave_Policy_ModuleField_Dropdown:
            return {
                ...state,
                getLeavePolicyModuleFieldDropdown: action.payload,
                loading: false,
            }
        // Settings Leave Policy

        // Settings Holiday Policy
        case types.post_Holiday_Policy_Data:
        case types.get_Holiday_Policy_Data:
            return {
                ...state,
                getHolidayPolicyData: action.payload,
                loading: false,
            }
        case types.get_SingleHoliday_Policy_Data:
            return {
                ...state,
                getSingleHolidayPolicyData: action.payload,
                loading: false,
            }
        case types.get_Country_Name_Dropdown:
            return {
                ...state,
                getCountryNameDropdown: action.payload,
                loading: false,
            }
        case types.get_Holiday_Name_Dropdown:
            return {
                ...state,
                getHolidayNameDropdown: action.payload,
                loading: false,
            }
        case types.get_Holiday_Policy_ModuleField_Dropdown:
            return {
                ...state,
                getHolidayPolicyModuleFieldDropdown: action.payload,
                loading: false,
            }
        // Settings Holiday Policy

        // Settings Financial Approval
        case types.post_Financial_Approval_Data:
        case types.get_Financial_Approval_Data:
            return {
                ...state,
                financialApprovalData: action.payload,
                loading: false,
            }
        case types.get_Approval_Level_Dropdown:
            return {
                ...state,
                approvalLevelDropdown: action.payload,
                loading: false,
            }
        case types.get_Single_Financial_Approval_Data:
            return {
                ...state,
                singleFinancialApprovalData: action.payload,
                loading: false,
            }
        case types.get_Financial_Approval_ModuleField_Dropdown:
            return {
                ...state,
                financialApprovalModuleFieldDropdown: action.payload,
                loading: false,
            }
        // Settings Financial Approval

        // Settings Functional Approval
        case types.post_Functional_Approval_Data:
        case types.get_Functional_Approval_Data:
            return {
                ...state,
                functionalApprovalData: action.payload,
                loading: false,
            }
        case types.get_Single_Functional_Approval_Data:
            return {
                ...state,
                singleFunctionalApprovalData: action.payload,
                loading: false,
            }
        case types.get_Functional_Approval_ModuleField_Dropdown:
            return {
                ...state,
                functionalApprovalModuleFieldDropdown: action.payload,
                loading: false,
            }
        // Settings Functional Approval

        // Settings Leave Approval
        case types.post_Leave_Approval_Data:
        case types.get_Leave_Approval_Data:
            return {
                ...state,
                leaveApprovalData: action.payload,
                loading: false,
            }
        case types.get_Single_Leave_Approval_Data:
            return {
                ...state,
                singleLeaveApprovalData: action.payload,
                loading: false,
            }
        case types.get_Leave_Approval_ModuleField_Dropdown:
            return {
                ...state,
                leaveApprovalModuleFieldDropdown: action.payload,
                loading: false,
            }
        // Settings Leave Approval

        // Settings Escalation Approval
        case types.post_Escalation_Approval_Data:
        case types.get_Escalation_Approval_Data:
            return {
                ...state,
                escalationApprovalData: action.payload,
                loading: false,
            }
        case types.get_Single_Escalation_Approval_Data:
            return {
                ...state,
                singleEscalationApprovalData: action.payload,
                loading: false,
            }
        case types.get_Escalation_Approval_ModuleField_Dropdown:
            return {
                ...state,
                escalationApprovalModuleFieldDropdown: action.payload,
                loading: false,
            }
        // Settings Escalation Approval

        // Settings Complaints Approval
        case types.post_Complaints_Approval_Data:
        case types.get_Complaints_Approval_Data:
            return {
                ...state,
                complaintsApprovalData: action.payload,
                loading: false,
            }
        case types.get_Single_Complaints_Approval_Data:
            return {
                ...state,
                singleComplaintsApprovalData: action.payload,
                loading: false,
            }
        case types.get_Complaints_Approval_ModuleField_Dropdown:
            return {
                ...state,
                complaintApprovalModuleFieldDropdown: action.payload,
                loading: false,
            }
        // Settings Complaints Approval

        // Settings Organization Chart
        case types.get_Organization_Chart:
            return {
                ...state,
                getOrganizationChart: action.payload,
                loading: false,
            }
        // Settings Organization Chart

        // Settings Menubar Enable and Disable
        case types.post_Modules_SubModules:
        case types.post_CustomField_Label_Change:
        case types.get_Module_SubModules:
            return {
                ...state,
                getModuleSubModules: action.payload,
                loading: false,
            }
        // Settings Menubar Enable and Disable

        // Settings Dynamic Dashboard
        case types.post_Dynamic_Dashboard_Data:
        case types.post_Default_Dashboard_Data:
        case types.get_Dynamic_Dashboard_Data:
            return {
                ...state,
                getDynamicDashboardData: action.payload,
                loading: false,
            }
        case types.get_Dynamic_Dashboard_Catogery_Dropdown:
            return {
                ...state,
                getDynamicDashboardCategoryDropdownData: action.payload,
                loading: false,
            }
        case types.get_Single_Dynamic_Dashboard_Data:
            return {
                ...state,
                getSingleDynamicDashboardData: action.payload,
                loading: false,
            }
        // Settings Dynamic Dashboard

        // Settings Module Fields
        case types.post_Module_Fields_Data:
        case types.get_Module_Fields_Data:
            return {
                ...state,
                getModuleFieldData: action.payload,
                loading: false,
            }
        case types.get_Column_Name:
            return {
                ...state,
                getColumnNameData: action.payload,
                loading: false,
            }
        case types.get_Single_Module_Field_Data:
            return {
                ...state,
                getSingleModuleFieldData: action.payload,
                loading: false,
            }
        // Settings Module Fields

        // eslint-disable-next-line no-fallthrough
        default:
            return state;
    }
}

export default designReducers;